import { defineComponent, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import UserInfoDropdownMenu from '@hems/component/src/dropdown/user/UserInfoDropdownMenu.vue';
import Image from '@hems/component/src/image/Image.vue';
import { useHomeownerInfo } from '@hems/util/src/composable/homeownerInfo';
import { useLanguage } from '@hems/util/src/composable/language';
import DropdownMenu from '@/components/header/DropdownMenu.vue';
export default defineComponent({
    name: 'Header',
    components: { Image, DropdownMenu, UserInfoDropdownMenu },
    props: {
        isLogin: {
            type: Boolean,
            default: false,
        },
        showMenu: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['logout', 'changeLanguage'],
    setup(_props, { emit }) {
        const { languageCode, languageOptionsForManagement } = useLanguage();
        const languageMenuRef = ref(null);
        const selectedLanguage = ref(languageCode.value);
        const languageDropdownItems = languageOptionsForManagement.value;
        const ACCOUNT_MENU = {
            ACCOUNT_INFO: 'account_info',
            LOGOUT: 'logout',
        };
        const { homeOwnerInfo } = useHomeownerInfo();
        const isOpenLanguageMenu = ref(false);
        const isOpenAccountMenu = ref(false);
        const toggleLanguageMenu = () => {
            isOpenLanguageMenu.value = !isOpenLanguageMenu.value;
            if (isOpenLanguageMenu.value && isOpenAccountMenu.value) {
                isOpenAccountMenu.value = false;
            }
        };
        const toggleAccountMenu = () => {
            isOpenAccountMenu.value = !isOpenAccountMenu.value;
            if (isOpenAccountMenu.value && isOpenLanguageMenu.value) {
                isOpenLanguageMenu.value = false;
            }
        };
        const onClickLanguage = (value) => {
            selectedLanguage.value = value;
            isOpenLanguageMenu.value = false;
            emit('changeLanguage', selectedLanguage.value);
        };
        const onClickAccountMenu = (value) => {
            switch (value) {
                case ACCOUNT_MENU.LOGOUT:
                    emit('logout');
                    break;
                default:
                    break;
            }
            isOpenAccountMenu.value = false;
        };
        onClickOutside(languageMenuRef, (event) => {
            if (event.target instanceof HTMLImageElement) {
                return;
            }
            isOpenLanguageMenu.value = false;
        });
        return {
            languageMenuRef,
            isOpenLanguageMenu,
            isOpenAccountMenu,
            selectedLanguage,
            languageDropdownItems,
            toggleLanguageMenu,
            toggleAccountMenu,
            onClickLanguage,
            onClickAccountMenu,
            homeOwnerInfo,
        };
    },
});
